import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useModalControl } from '@frontend/design-system';
import { CalendarViewV3HeaderFilterModal } from '../../../../components/CalendarViewV3Header/CalendarViewV3HeaderFilter/CalendarViewV3HeaderFilterModal';
import { FilterButton } from '../../../../components/filter-button';

export const FilterContainer = () => {
  const isLarge = useMatchMedia({ minWidth: breakpoints.large.min });

  const modalProps = useModalControl({
    disableReturnFocus: true,
  });

  return (
    <>
      <FilterButton iconOnly={isLarge} onClick={modalProps.openModal} />
      <CalendarViewV3HeaderFilterModal modalProps={modalProps} />
    </>
  );
};
